import { render, staticRenderFns } from "./GoalsComponent.vue?vue&type=template&id=61e2264b&scoped=true"
import script from "./GoalsComponent.vue?vue&type=script&lang=js"
export * from "./GoalsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e2264b",
  null
  
)

export default component.exports